import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const penaltyTypeLocaleModule: LocaleModule = {
  name: "penaltyType",
  messages: { en: en, it: it },
};
